import React from 'react'
import styled from '@emotion/styled'

/**
 * Componente pagina non trovata
 * @component
 */
export const NotFound: React.FC = () => {
  //TODO
  return <Container data-cy={'not-found-message'}>NOT FOUND</Container>
}

//region Style
const Container = styled.div`
  padding: 46px 30px 30px 30px;
`
//endregion
